module EEX.McEc.Helper {

    export function convertPieData(g: any): AppKitchen.Controls.Charts.PieChartDataItem {
        return { category: getLabelForStatus(g.Key), value: g.Elements.length, color: getColorForStatus(g.Key) };
    }

    export function getLabelForStatus(status: number): string {
        switch (status) {
            case McEc.Domain.CertificateState.Created:
                return McEc.Strings.CertificatesListe_State_Created;
            case McEc.Domain.CertificateState.Requested:
                return McEc.Strings.CertificatesListe_State_Requested;
            case McEc.Domain.CertificateState.Delayed:
                return McEc.Strings.CertificatesListe_State_Delayed;
            case McEc.Domain.CertificateState.Failed:
                return McEc.Strings.CertificatesListe_State_Failed;
            case McEc.Domain.CertificateState.Revoked:
                return McEc.Strings.CertificatesListe_State_Revoked;
            case McEc.Domain.CertificateState.Issued:
                return McEc.Strings.CertificatesListe_State_Issued;
            default:
                return "Not suppored";
        }
    }

    export function getColorForStatus(status: number): string {
        switch (status) {
            case McEc.Domain.CertificateState.Created:
                return "#00B1EB";
            case McEc.Domain.CertificateState.Requested:
                return "#2383D0";
            case McEc.Domain.CertificateState.Delayed:
                return "#EF8200";
            case McEc.Domain.CertificateState.Failed:
                return "#C4134D";
            case McEc.Domain.CertificateState.Revoked:
                return "#E5E5E5";
            case McEc.Domain.CertificateState.Issued:
                return "#AFCA0B";
            default:
                return null;
        }
    }

    export function isComplex(password: string): boolean {

        if (!settings.PasswordComplexity)
            return true;

        let res = 0;

        if (password.match(/^(?=.*[\d]).*$/)) {
            res++;
        }
        if (password.match(/^(?=.*[^\w\d\s]).*$/)) {
            res++;
        }
        if (password.match(/^(?=.*[a-z]).*$/)) {
            res++;
        }
        if (password.match(/^(?=.*[A-Z]).*$/)) {
            res++;
        }

        return !(res < 3);
    }
}